import styled from "styled-components";

export default styled("div")`
    display: flex;
    flex-direction: column;
    width: 320px;
    padding-top: 20px;
`;